/* Product page only (loaded when template.name == 'product'): gallery,
   zoom lightbox, live variant resolution (price/availability/URL without a
   reload), store-availability toggle and the sticky add-to-cart bar. */
(function () {
  var MM = (window.MesaMayor = window.MesaMayor || {});

  /* ---------- Gallery ---------- */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var mediaEls = document.querySelectorAll('[data-gallery-media]');
    if (!thumbs.length) return;

    function show(mediaId) {
      mediaEls.forEach(function (el) {
        var match = el.dataset.mediaId === String(mediaId);
        el.classList.toggle('is-active', match);
        el.hidden = !match;
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.dataset.mediaId); });
    });

    var initialMedia = document.querySelector('[data-gallery-media].is-active') || mediaEls[0]; if (initialMedia) show(initialMedia.dataset.mediaId);MM.showGalleryMedia = show;
  }

  /* ---------- Zoom lightbox ---------- */
  function initZoom() {
    var zoomBtn = document.querySelector('[data-gallery-zoom]');
    if (!zoomBtn) return;

    zoomBtn.addEventListener('click', function () {
      var active = document.querySelector('[data-gallery-media].is-active img, [data-gallery-media].is-active');
      var src = active && active.tagName === 'IMG' ? active.currentSrc || active.src : null;
      if (!src) return;

      var overlay = document.createElement('div');
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:90;background:rgba(22,21,15,.92);display:flex;align-items:center;justify-content:center;padding:24px;';
      overlay.innerHTML =
        '<button type="button" aria-label="Cerrar" style="position:absolute;top:20px;right:20px;width:44px;height:44px;background:transparent;border:1px solid #FAF8F4;color:#FAF8F4;font-size:22px;cursor:pointer;">&times;</button>' +
        '<img src="' + src + '" alt="" style="max-width:100%;max-height:90vh;object-fit:contain;">';

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
      var closeBtn = overlay.querySelector('button');
      closeBtn.focus();

      function close() {
        overlay.remove();
        document.body.style.overflow = '';
        zoomBtn.focus();
      }
      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
      });
    });
  }

  /* ---------- Store availability ---------- */
  function initStoreAvailability() {
    document.querySelectorAll('[data-store-availability-toggle]').forEach(function (link) {
      var panel = document.getElementById(link.getAttribute('aria-controls'));
      if (!panel) return;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var open = link.getAttribute('aria-expanded') === 'true';
        link.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-add-to-cart]');
    if (!bar || !anchor) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
        bar.setAttribute('aria-hidden', String(entry.isIntersecting));
      });
    }, { threshold: 0 });
    observer.observe(anchor);
  }

  /* ---------- Variant resolution ---------- */
  function initVariantPicker() {
    var section = document.querySelector('[data-product-section]');
    var jsonEl = document.querySelector('[data-product-variants-json]');
    if (!section || !jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var variantMediaMap = {};
    var mediaMapEl = document.querySelector('[data-variant-media-map]');
    if (mediaMapEl) {
      try { variantMediaMap = JSON.parse(mediaMapEl.textContent); } catch (err) { variantMediaMap = {}; }
    }

    var optionFieldsets = Array.prototype.slice.call(section.querySelectorAll('[data-variant-option]'));
    var idInput = section.querySelector('[data-variant-id-input]');
    var priceEl = section.querySelector('[data-price-target]');
    var compareEl = section.querySelector('[data-compare-target]');
    var badgeEl = section.querySelector('[data-badge-target]');
    var stockRow = section.querySelector('[data-stock-row]');
    var stockText = section.querySelector('[data-stock-text]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addPriceEl = section.querySelector('[data-add-to-cart-price]');

    function getSelected() {
      return optionFieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('[data-variant-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function fadePrice(cb) {
      if (!priceEl) { cb(); return; }
      priceEl.classList.add('is-fading');
      setTimeout(function () { cb(); priceEl.classList.remove('is-fading'); }, 150);
    }

    function updateAvailability(selected) {
      optionFieldsets.forEach(function (fieldset, index) {
        fieldset.querySelectorAll('[data-variant-input]').forEach(function (input) {
          var probe = selected.slice();
          probe[index] = input.value;
          var exists = variants.some(function (v) {
            return probe.every(function (val, i) { return val === null || v.options[i] === val; }) && v.available;
          });
          input.disabled = !exists;
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      fadePrice(function () {
        if (priceEl) priceEl.textContent = MM.formatMoney(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = MM.formatMoney(variant.compare_at_price);
        }
        if (badgeEl) badgeEl.hidden = !onSale;
      });

      if (stockRow) {
        if (!variant.available) {
          stockRow.dataset.state = 'out';
          if (stockText) stockText.textContent = 'Agotado';
        } else if (variant.inventory_management && variant.inventory_quantity <= 5) {
          stockRow.dataset.state = 'low';
          if (stockText) stockText.textContent = 'Quedan ' + variant.inventory_quantity;
        } else {
          stockRow.dataset.state = 'in';
          if (stockText) stockText.textContent = 'En stock · envío en 24 h';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addPriceEl) addPriceEl.textContent = MM.formatMoney(variant.price);
      }

      var mappedMediaId = variantMediaMap[variant.id];
      if (mappedMediaId && MM.showGalleryMedia) {
        MM.showGalleryMedia(mappedMediaId);
      } else if (variant.featured_image && MM.showGalleryMedia) {
        MM.showGalleryMedia(variant.featured_image.id);
      }

      optionFieldsets.forEach(function (fieldset, i) {
        var span = fieldset.querySelector('[data-option-selected-value]');
        if (span) span.textContent = variant.options[i];
      });
    }

    optionFieldsets.forEach(function (fieldset) {
      fieldset.addEventListener('change', function () {
        var selected = getSelected();
        updateAvailability(selected);
        var variant = findVariant(selected);
        applyVariant(variant);
      });
    });

    updateAvailability(getSelected());
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initZoom();
    initStoreAvailability();
    initStickyAtc();
    initVariantPicker();
  });
})();
